/**
 * DTO d'authentification (DECISIONS §4.2 — section Authentification).
 *
 * Le mot de passe et son hash ne sortent **jamais** de l'API. Le refresh token voyage
 * exclusivement dans un cookie `HttpOnly` `elemora_rt` : il n'apparaît dans aucun corps JSON.
 */
import { z } from 'zod';
import { progressionSchema, userSchema } from './models.js';
/** Réponse de `POST /auth/register` (`201`). */
export const registerResponseSchema = z
    .object({
    user: userSchema,
    progression: progressionSchema,
})
    .strict();
/** Réponse de `POST /auth/login` (`200`). */
export const loginResponseSchema = z
    .object({
    /** JWT d'accès, TTL 15 min, à garder **en mémoire** côté client. */
    accessToken: z.string().min(1),
    user: userSchema,
    progression: progressionSchema,
})
    .strict();
/** Réponse de `POST /auth/refresh` (`200`) — le refresh token est tourné. */
export const refreshResponseSchema = z.object({ accessToken: z.string().min(1) }).strict();
//# sourceMappingURL=auth.js.map